import { Component, ElementRef, OnDestroy } from "@angular/core";
import {
  faCalendarCheck,
  faCheck,
  faEye,
  faLock,
  faLockOpen,
  faPlus,
  faTrash,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PADataControl } from "../../singletons/pa-data-control";
import type { EditTourIdx, ShowTourIdx, TourIdxEditTour, TourIdxShowTour, TourIdxView } from "./tour-stopover.model";

@Component({
  selector: "hawk-tour-stopover",
  templateUrl: "./tour-stopover.component.html",
  styleUrls: [
    "./tour-stopover.component.scss",
    "./../../styles/common_styles.scss",
    "./../../../_shared/styles/common-styles.scss",
  ],
  standalone: true,
  imports: [FaIconComponent, TooltipModule, FontAwesomeModule],
})
export class TourStopoverComponent implements OnDestroy {
  protected readonly Math = Math;
  protected readonly faCalendarCheck = faCalendarCheck;
  protected readonly faLock = faLock;
  protected readonly faPlus = faPlus;
  protected readonly faLockOpen = faLockOpen;
  protected readonly faEye = faEye;
  protected readonly faTrash = faTrash;

  private _storeId: number;
  private _view: TourIdxView;

  constructor(public elRef: ElementRef) {}

  get storeId(): number {
    return this._storeId;
  }

  set storeId(id: number) {
    this._storeId = id;
    if (this.view.type == "edit") {
      this.view.tourStopoverEditModule.storeId = id;
    }
  }

  get view(): TourIdxView {
    return this._view;
  }

  set view(view: TourIdxView) {
    this._view = view;
  }

  update(): void {
    if (this.view.referenceTours && this.storeId) {
      this.updateTourIdxs(this.view.referenceTours);
    }
  }

  updateTourIdxs(tours: TourIdxShowTour[] | TourIdxEditTour[]): void {
    const res: (ShowTourIdx | EditTourIdx)[] = [];
    for (const tour of tours) {
      const operations = tour.operations;
      for (const operation of operations) {
        if (operation.storeId == this.storeId) {
          const op_idx = operations.indexOf(operation) + 1;
          res.push({
            tour: tour,
            idx: op_idx,
            operation_id: operation.id,
            color: tour.getColor(),
            done: operation.done,
            started: operation.started,
          });
        }
      }
    }
    this.view.tour_idxs = res;
  }

  ngOnDestroy(): void {
    console.log("Tour Stopover Component destroyed");
  }

  protected readonly faWrench = faWrench;
  protected readonly faCheck = faCheck;

  tourIdxSelectionChangeIsDisabledForOperation(operation_id: number): boolean {
    const operation = PADataControl.Instance.getOperation(operation_id);
    return !operation || operation.date_fixed || operation.started;
  }

  changeTourIdxSelection(tour_idx: EditTourIdx, event: Event): void {
    // Gewählte Tour-Nummer aus dem nativen Select übernehmen und die neue Tour-Konfiguration anstoßen
    const selected_value = (event.target as HTMLSelectElement).value;
    tour_idx.tour.technicianDate.insertionConfigMap.get(tour_idx.operation_id).tour_index =
      Number.parseInt(selected_value);
    tour_idx.tour.technicianDate.updateNewTourConfig();
  }
}
